import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { toast } from "sonner";
import { fileUrl, NETWORK_INFO } from "@/lib/api";

export const NetworkPicker = ({ wallets, value, onChange }) => (
  <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
    {wallets.map((w) => {
      const info = NETWORK_INFO[w.network];
      const active = value === w.network;
      return (
        <button
          key={w.network}
          type="button"
          data-testid={`crypto-network-${w.network.toLowerCase()}`}
          onClick={() => onChange(w.network)}
          className={`p-3 rounded-md border text-left transition-colors ${active ? "border-emerald-500 bg-emerald-500/10" : "border-white/10 bg-[#161922] hover:border-white/25"}`}
        >
          <span className="block font-mono font-bold text-sm" style={{ color: active ? "#10B981" : info.color }}>USDT · {info.label}</span>
          <span className="block text-xs text-gray-400 mt-1">{info.chain}</span>
        </button>
      );
    })}
  </div>
);

export const WalletPanel = ({ wallet, amount }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    await navigator.clipboard.writeText(wallet.address);
    setCopied(true);
    toast.success("Wallet address copied");
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <div data-testid="wallet-panel" className="grid sm:grid-cols-[180px_1fr] gap-5 sm:gap-6 items-center p-4 sm:p-5 rounded-lg border border-white/10 bg-[#161922]">
      <div className="bg-white p-3 rounded-md w-[180px] h-[180px] grid place-items-center mx-auto sm:mx-0">
        {wallet.qr_path
          ? <img data-testid="wallet-qr-image" src={fileUrl(wallet.qr_path)} alt={`${wallet.network} QR`} className="w-full h-full object-contain" />
          : <QRCodeSVG data-testid="wallet-qr-generated" value={wallet.address} size={156} />}
      </div>
      <div className="space-y-4 min-w-0">
        <div>
          <p className="label-eyebrow text-gray-500">Send exactly</p>
          <p data-testid="payment-amount" className="font-mono text-2xl font-bold text-emerald-400 mt-1">{amount} USDT</p>
          <p className="text-xs text-amber-400 mt-1">Only send USDT on the {NETWORK_INFO[wallet.network].chain} ({wallet.network}) network.</p>
        </div>
        <div>
          <p className="label-eyebrow text-gray-500 mb-2">Wallet address</p>
          <div className="flex gap-2">
            <code data-testid="wallet-address" className="flex-1 min-w-0 font-mono text-xs sm:text-sm break-all bg-[#08090C] border border-white/10 rounded-md px-3 py-2">{wallet.address}</code>
            <button type="button" data-testid="copy-wallet-address-button" onClick={copy} className="shrink-0 w-11 grid place-items-center rounded-md border border-white/10 hover:border-emerald-500 hover:text-emerald-400 transition-colors">
              {copied ? <Check size={16} /> : <Copy size={16} />}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
